import { observer } from "mobx-react-lite";
import React from "react";
import styled from "styled-components";
import {
  CvpBreadCrumb,
  CvpBreadCrumbProps,
} from "../../../generic-components/common/CvpBreadCrumb";
import { isAppTypeIframe } from "../../../getAppType";
import { EmbedNavMenu } from "./EmbedNavMenu";
import { useSettings } from "../../../settings/useSettings";
import { concatClassnames } from "../../../utils/util";

export interface CvpCardBreadCrumbProps extends CvpBreadCrumbProps {
  embedProps?: {
    showNavMenu?: boolean;
    showBreadCrumb?: boolean;
  };
  isHeader?: boolean;
  noPadding?: boolean;
}

export const CvpCardBreadCrumb = observer((props: CvpCardBreadCrumbProps) => {
  let { breadcrumbItems, embedProps, isHeader, noPadding } = props;

  const settings = useSettings();

  if (!isAppTypeIframe()) {
    return (
      <StyledCvpBreadCrumbContainer
        className={concatClassnames(["cvp-breadcrumb-container"])}
      >
        <CvpBreadCrumb
          breadcrumbItems={breadcrumbItems}
          className={concatClassnames([
            "cvp-card-breadcrumb",
            isHeader && "cvp-card-breadcrumb-header",
          ])}
        />
      </StyledCvpBreadCrumbContainer>
    );
  }

  const {
    showNavMenu = !!settings.iframe_showCardMenu,
    showBreadCrumb = !!settings.iframe_showCardMenu,
  } = embedProps ?? {};

  if (!showNavMenu && !showBreadCrumb) {
    return null;
  }

  return (
    <StyledCvpBreadCrumbContainer
      className={concatClassnames([
        "cvp-breadcrumb-container",
        "cvp-card-embed-breadcrumb",
      ])}
    >
      {!!showNavMenu && <EmbedNavMenu />}
      {!!showBreadCrumb && (
        <CvpBreadCrumb
          breadcrumbItems={breadcrumbItems}
          className={concatClassnames([
            isHeader && "cvp-card-breadcrumb-header",
            noPadding && "cvp-card-breadcrumb__no-padding",
          ])}
        />
      )}
    </StyledCvpBreadCrumbContainer>
  );
});

const StyledCvpBreadCrumbContainer = styled.div`
  &.cvp-card-embed-breadcrumb {
    display: flex;
    align-items: center;
    padding-right: 1rem;
    gap: 0.5rem;
    min-height: 4.5rem;
  }

  .cvp-card-breadcrumb-header .p-menuitem:not(.p-breadcrumb-home) {
    font-size: 1.5em;
  }
`;
